import { CreatorRendererLayer } from '@/renderer/types';
import { MathUtils, Vector3 } from 'three';

const BAR_THICKNESS = 0.08;

export const GRID_UNIT = 1.36 - BAR_THICKNESS,
	MODULE_BLOCK_HEIGHT = 1.48 - BAR_THICKNESS;

const RENDERER_CONFIG = {
	SCENE_BACKGROUND: 0xffffff,
	LIGHTS: {
		COLOR: 0xffffff,
		POS_Y: 100,
	},
	CAMERA: {
		ORTHO: {
			FRUSTRUM_SIZE: 25,
			MAX_ZOOM_IN: 5,
			MAX_ZOOM_OUT: 0.2,
			ZOOM_TICK: 0.25,
			INITIAL_ZOOM: 1,
		},
		PERSPECTIVE: {
			MIN_DISTANCE: 5,
			MAX_DISTANCE: 100,
			DISTANCE_TICK: 2.5,
			ENABLED_LAYERS: [
				CreatorRendererLayer.ROOM_WALL,
				CreatorRendererLayer.LANDSCAPE_MODULE,
				CreatorRendererLayer.PRODUCT_MODULE,
				CreatorRendererLayer.ROOM_VERTEX,
				CreatorRendererLayer.ROOM_WALL_LABEL,
				CreatorRendererLayer.ROOM_WALL_LINES,
			],
		},
	},
	SCREENSHOT: {
		WIDTH: 1920,
		HEIGHT: 1080,
		FLOOR_SIZE_OFFSET: 5,
		PERSPECTIVE_CAMERAS: [
			{
				POSITION: new Vector3(-15, 20, 15),
				TARGET: new Vector3(0, 0, 0),
			},
			{
				POSITION: new Vector3(15, 20, -15),
				TARGET: new Vector3(0, 0, 0),
			},
		],
	},
	CONTROLS: {
		PAN_SPEED: 0.8,
		MAX_POLAR_ANGLE: 85,
		SCREEN_SPACE_PANNING: false,
		ROTATE_SPEED: 10,
		ROTATE_TIME: 500,
	},
	INITIAL_ZOOM: 1,
	INITIAL_DISTANCE: 1,
	DRACO_DECODER_PATH: 'https://www.gstatic.com/draco/versioned/decoders/1.5.7/',
	MEASUREMENT: {
		LAYER: CreatorRendererLayer.MEASUREMENT,
		WIDTH: 3,
		POS_Y: 10,
		LINE_OFFSET: 0.25,
		LABEL_TO_LINE_OFFSET: 0.5,
	},
	DRAWING_VERTEX: {
		LAYER: CreatorRendererLayer.DRAWING_VERTEX,
		HEIGHT: 1,
		RADIUS: 0.25,
		CLOSE_THRESHOLD: 1,
	},
	DRAWING_LINE: {
		WIDTH: 5,
		HEIGHT: 0.05,
		LABEL_TO_LINE_OFFSET: 1,
	},
	ROOM_VERTEX: { LAYER: CreatorRendererLayer.ROOM_VERTEX },
	ROOM_WALL: {
		LAYER: CreatorRendererLayer.ROOM_WALL,
		POS_Y: 0.025,
		THICKNESS: 0.15,
		MIN_LENGTH: 0.25,
		MAX_LENGTH: 200,
		LABEL: {
			OFFSET_TO_WALL: 0.5,
			POS_Y: 0.5,
			LAYER: CreatorRendererLayer.ROOM_WALL_LABEL,
		},
		COLORS: {
			TOP: 0x5c5854,
			SIDE: 0xf0f2f4,
			HOVER: 0x845ef7,
			DRAGGING: 0x7048e8,
		},
		LINES: {
			LAYER: CreatorRendererLayer.ROOM_WALL_LINES,
		},
	},
	PLANE: {
		LAYER: CreatorRendererLayer.GRID_HELPER,
		POS_Y: -0.02,
		GRID: {
			POS_Y: 0.001,
			COLOR: 0xc9c9c9,
			SIZE: 200,
		},
	},
	FLOOR: {
		POS_Y: 0.0,
		LAYER: CreatorRendererLayer.FLOOR,
	},
	DRAGGABLE_OBJECT: {
		ROTATION_SNAP: MathUtils.degToRad(90),
	},
	PRODUCT_MODULE: {
		LAYER: CreatorRendererLayer.PRODUCT_MODULE,
	},
	LANDSCAPE_MODULE: {
		LAYER: CreatorRendererLayer.LANDSCAPE_MODULE,
		SNAP_TO_WALL_DISTANCE: 1,
	},
	MOUSE: {},
	GRID: {
		LAYER: CreatorRendererLayer.GRID_HELPER,
		GRID_UNIT: GRID_UNIT,
		BLOCK_HEIGHT: MODULE_BLOCK_HEIGHT,
		HELPER_SIZE: {
			SIZE: 100,
		},
	},
	COLORS: {
		GREEN: 0x087f5b,
		RED: 0xc92a2a,
		CREAM: 0xde9556,
		LIGHT_CREAM: 0xf8f2e7,
		BLACK: 0x141414,
		VIOLET: 0x6000cd,
	},
} as const;

export default RENDERER_CONFIG;
